export default [
  // route: string.includes(), will check entire route/path for provided string
  // event: event name to be displayed within Mixpanel
  {
    route: "renewal-premium-analysis",
    event: "User Leaves Renewal Premium Analysis"
  }
];
